import React from "react";
import styles from "./WhatsAppButton.module.css";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = () => {
  // Check if user is on mobile device
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  
  // Choose appropriate URL based on device
  const whatsappUrl = isMobile
    ? "https://wa.me/917259981441?text=Hi%20there"
    : "https://web.whatsapp.com/send?phone=917259981441&text=Hi%20there";

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.whatsappButton}
    >
      <FaWhatsapp size={32} />
    </a>
  );
};

export default WhatsAppButton;
